// Unpublished Work © 2020-2024 Deere & Company.

import React from 'react';
import PropTypes from 'Utils/prop-type-utils';
import {joinClassNames} from 'Utils/html-utils';
import {Button} from '@deere/isg.component-library';
import {connect} from 'react-redux';

function buttonContents(props) {
    return (
        <>
            {props.startIcon}
            <div className='onlink-btn-text'>
                {props.children}
            </div>
            {props.endIcon}
        </>
    );
}

function OnlinkButton(props) {
    const {isMigrated} = props;
    const color = props.color ? `onlink-btn-${props.color}` : null;
    const active = props.active ? 'onlink-btn-active' : null;
    const borderless = props.borderless ? 'onlink-btn-borderless' : null;

    const classNames = joinClassNames(
        'onlink-btn',
        color,
        active,
        borderless,
        props.className
    );

    if (isMigrated) {
        return (
            <Button
                disabled={props.disabled}
                endIcon={props.endIcon}
                onClick={props.onClick}
                startIcon={props.startIcon}
                type={props.type}
                variant={props.variant}
            >
                {props.children}
            </Button>
        );
    }

    return (
        <button
            className={classNames}
            disabled={props.disabled}
            onClick={props.onClick}
            type={props.type}
        >
            {buttonContents(props)}
        </button>
    );
}

OnlinkButton.propTypes = {
    active: PropTypes.bool,
    borderless: PropTypes.bool,
    children: PropTypes.node,
    className: PropTypes.string,
    color: PropTypes.string,
    disabled: PropTypes.bool,
    endIcon: PropTypes.node,
    isMigrated: PropTypes.bool,
    onClick: PropTypes.func,
    startIcon: PropTypes.node,
    type: PropTypes.string,
    variant: PropTypes.string
};
export function mapStateToProps(state) {
    return {
        isMigrated: state.membership?.isMigrated
    };
}

export default connect(mapStateToProps)(OnlinkButton);
